import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  wrapFormInput: {
    marginTop: 0,
  },
}));

export default useStyles;
